// ThreatLevelControl.jsx
// ══════════════════════════════════════════════
// בקרת רמת איום - Critical / High / Medium
// ══════════════════════════════════════════════

import { useEffect, useState } from "react";
import "../../../styles/navbar/CyberRoom/ThreatLevelControl.css";
import { useMamdani } from "../../../context/MamdaniContext";

const API_BASE = "https://api.anti-bot.ai";

const LEVELS = [
  { key: "CRITICAL", label: "CRITICAL", color: "#ff2244" },
  { key: "HIGH",     label: "HIGH",     color: "#ff8c00" },
  { key: "MEDIUM",   label: "MEDIUM",   color: "#ffd700" },
];

export default function ThreatLevelControl() {
  const [activeLevel, setActiveLevel] = useState("HIGH");
  const [stats, setStats]             = useState(null);
  const { mamdaniMode: mm, stats: mst } = useMamdani();

  useEffect(() => {
    if (mm) {
      // חשב רמת איום מנתוני ממדאני
      const level = mst.coordinated > 0 || mst.botsCount >= 5
        ? "CRITICAL"
        : mst.botsCount >= 2 ? "HIGH" : "MEDIUM";
      setActiveLevel(level);
      return;
    }
    async function fetchLevel() {
      try {
        const res  = await fetch(`${API_BASE}/api/cyber/live-stats`);
        const json = await res.json();
        if (json.success) {
          setStats(json);
          setActiveLevel(json.threat_level);
        }
      } catch (err) {
        console.error("ThreatLevelControl fetch error:", err);
      }
    }
    fetchLevel();
    const iv = setInterval(fetchLevel, 30000);
    return () => clearInterval(iv);
  }, [mm, mst]);

  return (
    <div className="tlc-wrapper">

      {/* כותרת */}
      <div className="tlc-header">
        <span className="tlc-title">{mm ? "Threat Level" : "בקרת רמת איום"}</span>
      </div>

      {/* כפתורים */}
      <div className="tlc-buttons">
        {LEVELS.map(({ key, label, color }) => {
          const isActive = activeLevel === key;
          return (
            <button
              key={key}
              className={`tlc-btn ${isActive ? "active" : ""}`}
              style={isActive ? {
                background: `${color}22`,
                borderColor: color,
                color: color,
                boxShadow: `0 0 10px ${color}55`,
              } : {}}
              onClick={() => !mm && setActiveLevel(key)}
            >
              {isActive && <span className="tlc-btn-dot" style={{ background: color }} />}
              {label}
            </button>
          );
        })}
      </div>

      {/* מידע נוסף */}
      {mm && (
        <div className="tlc-info">
          <span>Bots: <strong>{mst.totalBots}</strong></span>
          <span>Coordinated: <strong>{mst.coordinated}</strong></span>
        </div>
      )}

    </div>
  );
}